module.exports = __webpack_public_path__ + "static/assets/f428350accd2aca33c2fa7fb1bfc7ace.svg";